
$(function () {
    if ($('#edit-modal-blade-info').length){
        const targetElement = document.getElementById('edit-modal-blade-info');
        const dataObj = $(targetElement).data('obj');
        let route = dataObj.route;


        $('#itemEditModal').on('show.bs.modal', function (e) {
 
            // bootstrap datepicker has a bug that triggers this event and this check prevents the code from executing
            if (e.namespace === 'bs.modal') {
                const item = $(e.relatedTarget);
                const id = item.data('id');
                const name = item.data('name');
                let url = route;
                url = url.replace('ITEM_ID', id);

                $('#itemEditModalLabel').text(name);
                $('#itemEditModalContent').text("loading...").load(url, function () {

                    $('#zoneEdit').validate();
                    // now initialized in initialize-product-config-forms.js
                    // initProductConfigurations();
                    // initProductSizeConfigs();
                    // initOutsourcingManager('#orderProduct');

                    const $productForm = $('#orderProduct');
                    const $submitButton = $('#itemEditSubmit');
                    
                    $submitButton.on('click', function (event) {
                        event.preventDefault();
                        if ($productForm.valid()) {
                            document.getElementById('orderProduct').submit();
                        }
                    });
                });
            }
        });
    }
});